import { render, staticRenderFns } from "./ShowCurves.vue?vue&type=template&id=2cf3b79c&"
import script from "./ShowCurves.vue?vue&type=script&lang=js&"
export * from "./ShowCurves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports